import React from "react"

export default function StaffScheduling() {


  return (
    <div>
      <h1>Staff Scheduling</h1>
      
    </div>
  )
}
